import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'cardTitle'
	| 'spaceNameLabel'
	| 'spaceKeyLabel'
	| 'channelAccessLabel'
	| 'channelAccessClosedValue';

export const messages: Record<
	MessageKeys,
	{ id: string; defaultMessage: string; description?: string }
> = defineMessages({
	cardTitle: {
		id: 'jsm-solution-composer-plan.task-card.card-title',
		defaultMessage: 'Create Jira Service Management space',
		description: 'Title shown in the header of the Solution Composer create-space card',
	},
	spaceNameLabel: {
		id: 'jsm-solution-composer-plan.task-card.space-name-label',
		defaultMessage: 'Space name',
		description: 'Label for the space name shown in the create-space card summary',
	},
	spaceKeyLabel: {
		id: 'jsm-solution-composer-plan.task-card.space-key-label',
		defaultMessage: 'Space key',
		description: 'Label for the space key shown in the create-space card summary',
	},
	channelAccessLabel: {
		id: 'jsm-solution-composer-plan.task-card.channel-access-label',
		defaultMessage: 'Access',
		description: 'Label for the access setting shown in the create-space card summary',
	},
	channelAccessClosedValue: {
		id: 'jsm-solution-composer-plan.task-card.channel-access-closed-value',
		defaultMessage: 'Closed',
		description: 'Value indicating the created space has closed channel access',
	},
});
